import { render, staticRenderFns } from "./FormBlockLongText.vue?vue&type=template&id=2131d3c2&scoped=true&"
import script from "./FormBlockLongText.vue?vue&type=script&lang=js&"
export * from "./FormBlockLongText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131d3c2",
  null
  
)

export default component.exports